<template>
  <div class="app-step-two-tabs-order-type">
    <div class="app-step-two-tabs__wrapper">
      <div class="app-step-two-tabs-order-type__body">
        <app-button
          @click="() => handleClick(OrderTypes.Normal)"
          :class="{
            selected: orderStore.selectedOrderType === OrderTypes.Normal,
          }"
          :disabled="isLoading"
          :loading="isLoading"
          >My Press Release Document is Ready Now</app-button
        >
        <app-button
          v-if="orderStore.orderType !== OrderTypes.RedeemedCredit"
          :class="{
            selected: orderStore.selectedOrderType === OrderTypes.CreditOnly,
          }"
          :disabled="isLoading"
          :loading="isLoading"
          @click="() => handleClick(OrderTypes.CreditOnly)"
          >I Want to Purchase Credits for Later Use</app-button
        >
        <app-button
          @click="() => handleClick(OrderTypes.WritingService)"
          :class="{
            selected:
              orderStore.selectedOrderType === OrderTypes.WritingService,
          }"
          :disabled="isLoading"
          :loading="isLoading"
          >I Need Writing Service</app-button
        >
      </div>
    </div>

    <navigation-buttons
      :disabled-outer-condition="!orderStore.selectedOrderType"
      :loading="isLoading"
      @onPreviousButtonClick="
        updateOrder({ ...getFrontendTabBuilder() }, () => navigate())
      "
      @onNextButtonClick="
        updateOrder({ ...getFrontendTabBuilder(true) }, () => navigate(true))
      "
    ></navigation-buttons>
  </div>
</template>

<script setup>
import { OrderTypes } from '@modules/app-steps/step-two/tabs/tabs-data'
import { useOrder } from '@core/composables/order/useOrder'
import { useNavigationButtons } from '@modules/app-steps/step-two/navigation-buttons'

import { useTabsStore } from '@/stores/tabs'
import { storeToRefs } from 'pinia'

import AppButton from '@modules/ui/app-button.vue'
import NavigationButtons from '@modules/app-steps/step-two/navigation-buttons/index.vue'
import { useOrderStore } from '@/stores/order'
import { IS_MAIN_STORAGE_KEY } from '@modules/app-steps/step-one/useSpecialPackage'

const { getFrontendTabBuilder } = storeToRefs(useTabsStore())
const { useUpdateOrder } = useOrder()
const { isLoading, updateOrder } = useUpdateOrder()
const { navigate } = useNavigationButtons()

const orderStore = useOrderStore()

const handleClick = (orderType) => {
  // if (orderType === OrderTypes.CreditOnly) {
  //   localStorage.removeItem(IS_MAIN_STORAGE_KEY)
  // }
  orderStore.setSelectedOrderType(orderType)
  // Persist the chosen order type without advancing the wizard — the "Next"
  // button owns navigation. Previously this passed the next-tab metadata, which
  // auto-advanced on select and raced the Next button's own update.
  updateOrder({})
}
</script>
